export default __webpack_public_path__ + "1812c97bf97bfafbe916cf871a92c8dd.gif";